module.exports = __webpack_public_path__ + "media/images/blueimp/play-pause-aa3f7415c9c9eed0ee793ae973c7918f.svg";